var generic = generic || {};
var site = site || {};

(function ($) {
  site.emailSignupV4 = {
    templateContainer: $(),

    initEmailSignup: function () {
      var $emailContainerNodes = this.templateContainer;

      if ($emailContainerNodes.length <= 0) {
        return null;
      }
      $emailContainerNodes.each(function () {
        var params = {};
        var $emailContainerNode = $(this);
        var $emailForm = $emailContainerNode.is('form')
          ? $emailContainerNode
          : $('form', $emailContainerNode);
        var $emailSuccess = $('.js-email-signup__success', $emailContainerNode);
        var $emailError = $('.js-email-signup__error', $emailContainerNode);
        var $emailInput = $('input[name="PC_EMAIL_ADDRESS"]', $emailContainerNode);
        var $tosInputCheckbox = $('input[name="pc_email_promotions"]', $emailContainerNode);

        $emailForm.once('js-email-signup__form').on('submit', function (submitEvt) {
          let isTOSAccepted = false;
          submitEvt.preventDefault();
          $emailSuccess.add($emailError).addClass('hidden');
          $emailInput.removeClass('error');

          // Transform string into array of form elements

          $.each($emailForm.serializeArray(), function (index, kv) {
            params[kv.name] = kv.value.replace('undefined', '').replace('%40', '@');
          });
          if (!$tosInputCheckbox.is(':checked')) {
            params['pc_email_promotions'] = '0';
          }
          isTOSAccepted = params.pc_email_promotions && params.pc_email_promotions === '1';
          $tosInputCheckbox.parent().toggleClass('error', !isTOSAccepted);

          if (!isTOSAccepted && $emailInput.val() !== '') {
            return false;
          }

          // Send the data via a json rpc call
          generic.jsonrpc.fetch({
            method: 'rpc.form',
            params: [params],
            onSuccess: function (jsonRpcResponse) {
              var response = jsonRpcResponse.getData();
              var alreadySignedUp = response.userinfo.previously_opted_in_email_promotion;

              if (alreadySignedUp) {
                $(document).trigger('email_signup:success_but_signed_up');
              } else {
                $(document).trigger('email_signup:success_and_new');
              }

              if ($emailSuccess.hasClass('inline')) {
                $emailSuccess.removeClass('hidden');
              } else {
                // Close active utility items
                $('.js-gnav-util__content').addClass('hidden');
                $emailInput.val('');
                generic.overlay.launch({
                  height: 'auto',
                  cssClass: self.colorBoxClassName,
                  html: $emailSuccess.html()
                });
              }
            },
            // overrides for the default error handler
            statusCode: {},
            onFailure: function () {
              $emailError.removeClass('hidden');
              $emailInput.addClass('error');
            }
          });
        });
      });
    }
  };

  Drupal.behaviors.emailSignupV4V4 = {
    attach: function (context) {
      site.emailSignupV4.templateContainer = $('.js-email-signup-v4', context);
      site.emailSignupV4.initEmailSignup();
    }
  };
})(jQuery);
